import { CoverageEvent } from "@graphql/api";

import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { formatAwsDateString } from "@covertree/utils";

import { mapEventType } from "@utils/mapEventType/mapEventType";
import { Link, useLocation } from "react-router-dom";
import {
  BASE_COVERAGE_PATH,
  COVERAGE_ROUTES,
} from "@routing/Residents/ProofOfCoverage";

interface PolicyEventsListProps {
  coverageId: string;
  events: CoverageEvent[];
}

export function PolicyEventsList({
  coverageId,
  events,
}: PolicyEventsListProps) {
  const location = useLocation();

  return (
    <Grid
      container
      display="flex"
      flexDirection="column"
      alignItems="flex-start"
      justifyItems="flex-start"
      gap={3}>
      {events.map((event) => (
        <Stack
          display="flex"
          width="100%"
          justifyContent="space-between"
          direction="row"
          key={event.id}
          spacing={2}>
          <Typography>
            {formatAwsDateString(event.date)} - {mapEventType(event.type)}
          </Typography>
          <Button
            component={Link}
            variant="text"
            to={`${location.pathname}/${BASE_COVERAGE_PATH}/${coverageId}/${COVERAGE_ROUTES.EVENT}/${event.id}`}
            sx={{
              padding: 0,
              height: "auto",
              "&:hover": { background: "none" },
            }}>
            View
          </Button>
        </Stack>
      ))}
    </Grid>
  );
}
